// extracted by mini-css-extract-plugin
export default {"header__link":"HeaderAnchorLinkWithReload_header__link__OQGZi"};